'use client';

import { CalendarMobileFilters } from '@/app/(main)/calendar/components/CalendarMobileFilters';
import { CalendarMobileHeader } from '@/app/(main)/calendar/components/CalendarMobileHeader';
import { CalendarMobileWeekStrip } from '@/app/(main)/calendar/components/CalendarMobileWeekStrip';
import type { CalendarViewMode, CalendarVisibilityState } from '@/types/calendarTypes';

type CalendarMobileToolbarProps = {
  view: CalendarViewMode;
  navTitle: string;
  selectedDate: Date;
  visibility: CalendarVisibilityState;
  onPrevious: () => void;
  onNext: () => void;
  onViewSegment: (view: CalendarViewMode) => void;
  onVisibilityChange: (next: CalendarVisibilityState) => void;
  onWeekDateSelect: (date: Date) => void;
};

export function CalendarMobileToolbar({
  view,
  navTitle,
  selectedDate,
  visibility,
  onPrevious,
  onNext,
  onViewSegment,
  onVisibilityChange,
  onWeekDateSelect,
}: CalendarMobileToolbarProps) {
  return (
    <div className="flex shrink-0 flex-col md:hidden">
      <CalendarMobileHeader
        handleViewSegment={onViewSegment}
        onPrevious={onPrevious}
        onNext={onNext}
        view={view}
        navTitle={navTitle}
        isWidget={false}
      />
      {view === 'day' ? (
        <CalendarMobileWeekStrip selectedDate={selectedDate} onSelectDate={onWeekDateSelect} />
      ) : null}
      <CalendarMobileFilters visibility={visibility} onVisibilityChange={onVisibilityChange} />
    </div>
  );
}
